import { OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { Request } from '../request.model';
import { takeUntil } from 'rxjs/operators';
var RequestFormDialogComponent = /** @class */ (function () {
    /**
     * Constructor
     *
     * @param {MatDialogRef<RequestFormDialogComponent>} matDialogRef
     * @param _data
     * @param {FormBuilder} _formBuilder
     */
    function RequestFormDialogComponent(matDialogRef, _data, _requestService, _formBuilder, _matSnackBar, _companyService, _translate, _translationLoader) {
        this.matDialogRef = matDialogRef;
        this._data = _data;
        this._requestService = _requestService;
        this._formBuilder = _formBuilder;
        this._matSnackBar = _matSnackBar;
        this._companyService = _companyService;
        this._translate = _translate;
        this._translationLoader = _translationLoader;
        this.lang = 'sr';
        this._unsubscribeAll = new Subject();
        // Set the defaults
        this.action = _data.action;
        this.dialogTitle = 'New request';
        this.request = new Request({});
        this.requestForm = this.createRequestForm();
    }
    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------
    RequestFormDialogComponent.prototype.getTranslations = function () {
        var _this = this;
        this._translationLoader.getLastLang()
            .then(function (response) {
            _this.lang = response['code'];
            _this._translationLoader.getTranslations(_this.lang, '23');
        })
            .catch(function (err) { return Promise.reject(err); })
            .then(function () {
        }, function (err) {
        });
    };
    Object.defineProperty(RequestFormDialogComponent.prototype, "f", {
        // convenience getter for easy access to form fields
        get: function () { return this.requestForm.controls; },
        enumerable: true,
        configurable: true
    });
    RequestFormDialogComponent.prototype.checkTypeChange = function (type) {
        this.selectedType = type.triggerValue;
    };
    /**
     * Create city form
     *
     * @returns {FormGroup}
     */
    RequestFormDialogComponent.prototype.createRequestForm = function () {
        return this._formBuilder.group({
            id: [this.request.id],
            type: [this.request.type],
            comment: [this.request.comment]
        });
    };
    RequestFormDialogComponent.prototype.checkServerError = function (fieldName) {
        return this.requestForm.get(fieldName).errors ? this.requestForm.get(fieldName).errors.serverError ?
            this.requestForm.get(fieldName).errors.serverError : this._translate.instant('This field is required!') : false;
    };
    RequestFormDialogComponent.prototype.createRequest = function (requestForm) {
        var _this = this;
        this._requestService.createRequest(requestForm.getRawValue().type.id, requestForm.getRawValue().comment, this.company.id)
            .then(function (x) {
            _this.matDialogRef.close(['save', requestForm]);
            // Show the success message
            _this._matSnackBar.open(_this._translate.instant('Request') + ' ' + requestForm.getRawValue().type.name + _this._translate.instant(' created successfully.'), '', {
                verticalPosition: 'top',
                horizontalPosition: 'right',
                duration: 2000
            });
        })
            .catch(function (err) { return Promise.reject(err); })
            .then(function (x) { }, function (err) {
            var formControl = _this.requestForm.get('request');
            console.log(err);
            if (formControl) {
                formControl.setErrors({
                    serverError: err.error.message
                });
            }
            console.log('Error:', err.statusText);
        });
    };
    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------
    RequestFormDialogComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._companyService.getActiveCompany()
            .then(function (response) {
            _this.company = response;
        })
            .catch(function (err) { return Promise.reject(err); })
            .then(function () {
            _this._requestService.getAllRequestTypes(_this.company.id)
                .then(function (response) {
                _this.requestTypes = response.data;
            });
        }, function (err) {
        });
        this._translationLoader.onLangChanged
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(function (value) {
            _this.getTranslations();
        });
        this.getTranslations();
    };
    RequestFormDialogComponent.prototype.ngOnDestroy = function () {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    };
    return RequestFormDialogComponent;
}());
export { RequestFormDialogComponent };
